import { createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkActions } from './types';
import { DataLayerEvent } from '../analytics';

export const trackEvent = createAsyncThunk(ThunkActions.trackEvent, async (input: DataLayerEvent) => {
  (window.adobeDataLayer || []).push(input);
});
